import styled from 'styled-components';

const Header = styled.header`
  margin: 0;
  font-weight: bold;
  font-size: 4rem;
`;

export default Header;
